export const advRoute = {
    path: "/adv",
    name: "广告数据",
    meta: { title: "广告数据", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "retention_adv",
            name: "新用户留存广告",
            component: resolve =>
                require(["@/components/adv/retentionAdv"], resolve),
            meta: { title: "新用户留存广告" }
        },
        {
            path: "retention_launch",
            name: "广告投放回本",
            component: resolve =>
                require(["@/components/adv/retentionLaunch"], resolve),
            meta: { title: "广告投放回本" }
        },
        {
            path: "daily_adv",
            name: "用户广告",
            component: resolve => require(["@/components/adv/dailyAdv"], resolve),
            meta: { title: "用户广告" }
        },
        {
            path: "adv_detail",
            name: "广告详细",
            component: resolve =>
                require(["@/components/adv/advDetail"], resolve),
            meta: { title: "广告详细" }
        },
        {
            path: "distribution",
            name: "广告分布",
            component: resolve =>
                require(["@/components/adv/distribution"], resolve),
            meta: { title: "广告分布" }
        },
        {
            path: "hour_user",
            name: "新用户平均广告",
            component: resolve =>
                require(["@/components/adv/hourUserAdv"], resolve),
            meta: { title: "新用户平均广告" }
        },
        {
            path: "record",
            name: "广告实时数据",
            component: resolve =>
                require(["@/components/adv/realTimeAdv"], resolve),
            meta: { title: "广告实时数据" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/adv.js